import React from 'react';
import ReactDOM from 'react-dom/client';
import { AuthProvider } from './contexts/AuthContext';
import { SubscriptionProvider } from './contexts/SubscriptionContext';
import { TreeProvider } from './contexts/TreeContext';
import App from './components/App';
import { installErrorReporting } from './utils/errorReporting';

// Before any rendering, so a crash during the first render is still captured.
installErrorReporting();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvider>
      <SubscriptionProvider>
        <TreeProvider>
          <App />
        </TreeProvider>
      </SubscriptionProvider>
    </AuthProvider>
  </React.StrictMode>
);
